import { Injectable } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { TranslationConfiguration } from '../models/view.model';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  public resAsync: Promise<ResourceSet>;
  public res: ResourceSet = ResourceSet.Empty;
  public translation: TranslationConfiguration;

  constructor(private resourcesService: ResourceManagerService) {
    this.resAsync = this.resourcesService.getResourceSet('abc-opath-expressions');
    this.initializeTranslation();
  }

  public async initializeTranslation(): Promise<void> {
    this.res = await this.resAsync;
    this.translation = {
      menu: {
        saveAndClose: this.res.get('menu-saveAndClose'),
        reset: this.res.get('menu-reset'),
        undo: this.res.get('menu-undo'),
        redo: this.res.get('menu-redo'),
        validate: this.res.get('menu-validate'),
        neutralDesignation: this.res.get('menu-neutralDesignation'),
      },
      attribute: {
        title: this.res.get('attribute-title'),
        keyColumns: this.res.get('attribute-keyColumns'),
        systemColumns: this.res.get('attribute-systemColumns'),
      },
      functions: {
        title: this.res.get('functions-title'),
      },
      operators: {
        title: this.res.get('operators-title'),
        changePosition: this.res.get('operators-change-position'),
        unpin: this.res.get('operators-unpin'),
      },
      search: {
        title: this.res.get('search-title'),
        matchCase: this.res.get('search-matchCase'),
        wohleWord: this.res.get('search-wohleWord'),
        previousMatch: this.res.get('search-previousMatch'),
        nextMatch: this.res.get('search-nextMatch'),
        allMatch: this.res.get('search-allMatch'),
        results: this.res.get('search-results'),
        noResults: this.res.get('search-noResults'),
        placeholder: this.res.get('search-placeholder'),
      },
      replace: {
        title: this.res.get('replace-title'),
        placeholder: this.res.get('replace-placeholder'),
        one: this.res.get('replace-one'),
        all: this.res.get('replace-all'),
      },
      validation: {
        title: this.res.get('validation-title'),
        expressionChanged: this.res.get('validation-expressionChanged'),
        valid: this.res.get('validation-valid'),
        invalid: this.res.get('validation-invalid'),
        button: this.res.get('validation-button'),
        isRefError: this.res.get('validation-isRefError'),
        typeError: this.res.get('validation-typeError'),
      },
      generator: {
        title: this.res.get('generator-title'),
        placeholder: this.res.get('generator-placeholder'),
        errorMessage: this.res.get('generator-errorMessage'),
        noResult: this.res.get('generator-noResult'),
        assistantName: this.res.get('generator-assistantName'),
      },
      of: this.res.get('of'),
      pin: this.res.get('pin'),
      columnTitle: this.res.get('column-title'),
      popUpTitle: this.res.get('pop-up-title'),
    };
  }
}
